function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { useEditorRef } from 'platejs/react';
import { useLinkToolbarButton, useLinkToolbarButtonState } from '@platejs/link/react';
import { unwrapLink, upsertLink } from '@platejs/link';
import ToolbarButton from './ToolbarButton';
import { jsx as ___EmotionJSX } from "@emotion/react";
function LinkToolbarButton({
  t,
  ...rest
}) {
  const state = useLinkToolbarButtonState();
  const {
    props: {
      pressed
    }
  } = useLinkToolbarButton(state);
  const editor = useEditorRef();
  function handleClick() {
    const url = window.prompt(t('editor.editorWidgets.markdown.linkPrompt'), '');
    if (url) {
      upsertLink(editor, {
        url,
        skipValidation: true
      });
    } else if (url == '') {
      unwrapLink(editor);
    }
  }
  return ___EmotionJSX(ToolbarButton, _extends({
    isActive: pressed,
    onClick: handleClick
  }, rest));
}
export default LinkToolbarButton;